// Bloomreach's personalization panel copies {{ customer.first_name }}, but the shared template component refuses
// Save on a literal {{ }}. These rewrite a well-formed one to the single-brace form we write everywhere else.
// {% ... %}, {# ... #}, an unclosed {{ and nested braces stay as typed.
const DOUBLE_BRACE_TOKEN_RE = /\{\{\s*([^\s{}%#][^{}]*?)\s*\}\}/g;

export const collapseDoubleBraces = (value) => String(value ?? '').replace(DOUBLE_BRACE_TOKEN_RE, '{$1}');

// Rewrites the field the way a keystroke would. React tracks a controlled field's value on the element, so a plain
// `field.value = ...` would hide the change from its onChange; the prototype's setter plus an input event doesn't.
// The event finds no {{ left to rewrite, so it can't loop. Returns whether the field changed.
// A field we rewrite on focusout has already lost focus, so it has no caret to keep: we leave its selection alone.
export function rewriteFieldDoubleBraces(field) {
  const before = field.value;
  if (typeof before !== 'string') return false;
  const after = collapseDoubleBraces(before);
  if (after === before) return false;

  // Setting a value sends the caret to the end. A focused field gets it back, shifted left by what was removed before it.
  const caret = field.selectionStart;
  const proto = field.tagName === 'TEXTAREA' ? HTMLTextAreaElement.prototype : HTMLInputElement.prototype;
  Object.getOwnPropertyDescriptor(proto, 'value').set.call(field, after);
  const focused = field.ownerDocument.activeElement === field;
  if (focused && typeof caret === 'number' && typeof field.setSelectionRange === 'function') {
    const next = collapseDoubleBraces(before.slice(0, caret)).length;
    field.setSelectionRange(next, next);
  }
  field.dispatchEvent(new Event('input', { bubbles: true }));
  return true;
}
